// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "LeftNavWrapper-module--cds--assistive-text--0f63f";
export var cdsHideFeedback = "LeftNavWrapper-module--cds--hide-feedback--d7839";
export var cdsShowFeedback = "LeftNavWrapper-module--cds--show-feedback--f706a";
export var cdsSkeleton = "LeftNavWrapper-module--cds--skeleton--d4462";
export var cdsVisuallyHidden = "LeftNavWrapper-module--cds--visually-hidden--70c7a";
export var expanded = "LeftNavWrapper-module--expanded--e2d5f";
export var leftNavWrapper = "LeftNavWrapper-module--leftNavWrapper--20f7e";
export var useHeaderNavStyles = "LeftNavWrapper-module--useHeaderNavStyles--7962e";